import { _omitKeys } from "../../helper-payroll/HelperFunction";
export const _delSpecificFields = (res, caseChecker, joCases) => {
  console.log("joCases", joCases);
  if (caseChecker("isFourthCase")) {
    delete res.OfDutyForCiaMciaBinocRangeTo1519;
    delete res.airportAugmentationRate;
    delete res.amountEarnedAirportAugmentation;
    delete res.earnedCurrentAssignment;
    delete res.latesUtPerMinute;
    delete res.latesUtPerMinute2;
    delete res.latesUtPerMinute3;
    delete res.latesUtPerMinute4;
    delete res.absencesLeaves;
    delete res.absencesLeaves2;
    delete res.apRate;
    delete res.y247N700530;
    delete res.abs;
    delete res.abs2;
  }
  if (caseChecker("isSecondCase") || caseChecker("isThirdCase")) {
    delete res.deductionsDueToLeavesAbsencesAndTardinessBasic;
    delete res.monthNamesArr;
    delete res.updatedCountPrd;
    delete res.dateOfAbsences;
    delete res.dateOfHalfDays;
    delete res.leaveWithoutPayDates;
    delete res[2];
    delete res[3];
    delete res[5];
    delete res[10];
  }
  if (caseChecker("isFifthCase")) {
    delete res[2];
    delete res[3];
    delete res[5];
    delete res[10];
    delete res.minsToBeDeducted;
  }

  if (caseChecker("isSixthCase")) {
    delete res[2];
    delete res[3];
    delete res[5];
    delete res[10];
    delete res.minsToBeDeducted;
    delete res.monthNamesArr;
    delete res.updatedCountPrd;
  }
  if (caseChecker("isSeventhCase")) {
    delete res.OfDays1Month;
    delete res.days;
    delete res.halfDays;
    delete res.halfDays2;
    delete res.days2;
    delete res.days3;
    delete res.mins;
    delete res.mins2;
    delete res.mins3;
    delete res.perDay;
    delete res.perDay2;
    delete res.perMinute;
    delete res.perMinute2;
    delete res.plantillaItems;
    delete res.total;
  }
  if (caseChecker("isEightCase")) {
    delete res.OfDutyForCiaMciaBinocRangeTo1519;
    delete res.payCode;
    delete res.monthNamesArr;
    delete res.updatedCountPrd;
    delete res.y247N700530;
    delete res.workingDates;
    delete res.minsToBeDeducted;
    delete res.plantillaItems;
    delete res.apRate;
    delete res.allMinsIncurred;
  }
  if (caseChecker("isNinthCase")) {
    delete res.numberOfWorkdaysOfActualWorkPerformanceInAMonth;
    delete res.representationAllowanceTransportationAllowanceRata;
  }
  if (joCases?.isJoBackPay) {
    delete res.OfDutyForCiaMciaBinocRangeTo1519;
    delete res.minsToBeDeducted;
    delete res.tax3;
    delete res.monthNamesArr;
    delete res.updatedCountPrd;
    delete res.workingDates;
    delete res.minsDeducted;
    delete res.netPay;
    delete res.basicSalary;
    delete res.allMinsIncurred;
    delete res[2];
    delete res[20];
    delete res.totalEarned;
  }
  if (joCases?.isJoInitial) {
    delete res.OfDutyForCiaMciaBinocRangeTo1519;
    delete res[2];
    delete res[20];
    delete res.absMins;
    delete res.basicSalary;
    delete res.basicSalary;
    delete res.tax3;
    delete res.minsDeducted;
  }
  if (caseChecker("isTwelvethCase")) {
    delete res.OfDutyForCiaMciaBinocRangeTo1519;
    delete res.abs;
    delete res.abs2;
    delete res.absencesLeaves;
    delete res.absencesLeaves2;
    delete res.latesUtPerMinute;
    delete res.latesUtPerMinute2;
    delete res.latesUtPerMinute3;
    delete res.latesUtPerMinute4;
    delete res.monthNamesArr;
    delete res.workingDates;
    delete res.updatedCountPrd;
    delete res.y247N700530;
    delete res.payCode;
  }
  if (caseChecker("isFourteenthCase")) {
    delete res.earnedForThePeriod;
    delete res.earnedForThePeriod2;
    delete res["20EarnedAmount"];
    delete res[3];
  }
  return res;
};

export const _buildPayrollData = (params) => {
  const {
    res,
    cleanedItem,
    allContributions,
    formattedCsvArray,
    payrollID,
    id,
    netPay,
    pera,
    netofMandatory,
    taxDue,
    basic,
    caseChecker,
    selectedTypes,
    datePicked,
    joCases,
  } = params;

  const payrollData = {
    payrollID,
    oldRate: caseChecker("isSeventhCase") ? (res?.gross ?? 0) : (basic ?? 0),
    employee: { id: id },
    payrollType: selectedTypes?.payrollTypeVal,
    jobType: selectedTypes?.jobTypeVal,
    payItem: selectedTypes?.payItems,
    startDate: datePicked?.startDate,
    endDate: datePicked?.endDate,
    contributions:
      caseChecker("isFourthCase") || caseChecker("isTenthCase")
        ? []
        : allContributions,
    deductions: formattedCsvArray,
    ...res,
  };
  if (
    !caseChecker("isThirdCase") &&
    !caseChecker("isFourthCase") &&
    !caseChecker("isTenthCase")
  ) {
    payrollData.contributions = allContributions;
  }
  if (caseChecker("isFirstCase")) {
    payrollData.peraAda = pera;
    payrollData.netOfMandatory = netofMandatory;
    payrollData.taxDue = taxDue;
    payrollData.netAmount = netPay;
  } else if (caseChecker("isSecondCase")) {
    payrollData.peraAda = pera;
    payrollData.netAmount = netPay;
    payrollData.netOfMandatory = netofMandatory;
    payrollData.taxDue = taxDue;
    payrollData.deductionDueToLeavesTardy =
      cleanedItem.deductionsDueToLeavesAbsencesAndTardinessBasic;
  } else if (caseChecker("isThirdCase")) {
    payrollData.deductionDueToLeavesTardy =
      cleanedItem.deductionsDueToLeavesAbsencesAndTardinessBasic;
    payrollData.selectedDate = cleanedItem.monthNamesArr;
    payrollData.netAmount = netPay;
  } else if (caseChecker("isFourthCase")) {
    payrollData.taxDue = taxDue;
    payrollData.dutyForCiaMciaBinoc =
      cleanedItem.OfDutyForCiaMciaBinocRangeTo1519;
    payrollData.airportAugRate = cleanedItem.airportAugmentationRate;
    payrollData.earnedAirportAug = cleanedItem.amountEarnedAirportAugmentation;
    payrollData.earnedCurrAssignment = cleanedItem.earnedCurrentAssignment;
    payrollData.latesUTMinsPresent = cleanedItem.latesUtPerMinute;
    payrollData.latesUTMinsAirport = cleanedItem.latesUtPerMinute2;
    payrollData.latesUTMinsCurrent = cleanedItem.latesUtPerMinute3;
    payrollData.latesUTMinsAirportAug = cleanedItem.latesUtPerMinute4;
    payrollData.absencesPresent = cleanedItem.abs;
    payrollData.absencesAugmentation = cleanedItem.abs2;
    payrollData.absencesLeavesCurrAss = cleanedItem.absencesLeaves;
    payrollData.absencesLeavesAirportAss = cleanedItem.absencesLeaves2;
    payrollData.payCode = cleanedItem.apRate;
    payrollData.assignedArea = cleanedItem.y247N700530;
  } else if (caseChecker("isFifthCase")) {
    payrollData.minutesToBeDeducted = cleanedItem.minsToBeDeducted;
    payrollData.threePercent = cleanedItem[3];
    payrollData.twoPercent = cleanedItem[2];
    payrollData.fivePercent = cleanedItem[5];
    payrollData.tenPercent = cleanedItem[10];
    payrollData.netAmount = netPay;
  } else if (caseChecker("isSixthCase")) {
    payrollData.minutesToBeDeducted = cleanedItem.minsToBeDeducted;
    payrollData.threePercent = cleanedItem[3];
    payrollData.twoPercent = cleanedItem[2];
    payrollData.fivePercent = cleanedItem[5];
    payrollData.tenPercent = cleanedItem[10];
    payrollData.selectedDate = cleanedItem.monthNamesArr;
    payrollData.netAmount = netPay;
  } else if (caseChecker("isSeventhCase")) {
    payrollData.daysInAMonth = cleanedItem.OfDays1Month;
    payrollData.perDayBasic = cleanedItem.perDay;
    payrollData.perMinuteBasic = cleanedItem.perMinute;
    payrollData.perDayPera = cleanedItem.perDay2;
    payrollData.perMinutePera = cleanedItem.perMinute2;
    payrollData.daysDeduction = cleanedItem.days;
    payrollData.halfdaysDeduction = cleanedItem.halfDays;
    payrollData.minsDeduction = cleanedItem.mins;
    payrollData.daysBasic = cleanedItem.days2;
    payrollData.halfdaysBasic = cleanedItem.halfDays2;
    payrollData.minsBasic = cleanedItem.mins2;
    payrollData.basic = cleanedItem.basic;
    payrollData.daysPera = cleanedItem.days3;
    payrollData.minsPera = cleanedItem.mins3;
    payrollData.pera = cleanedItem.pera;
    payrollData.gsisInsuredDays = cleanedItem.daysForGsis;
    payrollData.basicEarned = cleanedItem.basicEarned;
    payrollData.peraAdaEarned = cleanedItem.peraAdaEarned;
    payrollData.totalforBasicPera = cleanedItem.total;
    payrollData.netAmount = netPay;
  } else if (caseChecker("isEightCase")) {
    payrollData.dutyForCiaMciaBinoc =
      cleanedItem.OfDutyForCiaMciaBinocRangeTo1519;
    payrollData.assignedArea = cleanedItem.y247N700530;
    payrollData.minutesToBeDeducted = cleanedItem.minsToBeDeducted;
    payrollData.netAmount = netPay;
  } else if (caseChecker("isNinthCase")) {
    payrollData.actualWorkPerformance =
      cleanedItem.numberOfWorkdaysOfActualWorkPerformanceInAMonth;
    payrollData.rataAllowance =
      cleanedItem.representationAllowanceTransportationAllowanceRata;
  } else if (caseChecker("isTenthCase")) {
    payrollData.netAmount = netPay;
  } else if (joCases.isJoBackPay) {
    payrollData.dutyForCiaMciaBinoc =
      cleanedItem.OfDutyForCiaMciaBinocRangeTo1519;
    payrollData.minutesToBeDeducted = cleanedItem.minsToBeDeducted;
    payrollData.twentyPercent = cleanedItem[20];
    payrollData.threePercent = [cleanedItem.tax3];
    payrollData.totalEarned = [cleanedItem.totalEarned];
    payrollData.selectedDate = cleanedItem.monthNamesArr;
  } else if (joCases.isJoInitial) {
    payrollData.dutyForCiaMciaBinoc =
      cleanedItem.OfDutyForCiaMciaBinocRangeTo1519;
    payrollData.minutesToBeDeducted = cleanedItem.minsDeducted;
    payrollData.absencesMins = cleanedItem.absMins;
    payrollData.threePercent = cleanedItem.tax3;
    payrollData.twentyPercent = cleanedItem[20];
  } else if (caseChecker("isTwelvethCase")) {
    payrollData.dutyForCiaMciaBinoc =
      cleanedItem.OfDutyForCiaMciaBinocRangeTo1519;
    payrollData.absPresentAss_1 = cleanedItem.abs;
    payrollData.lateUTperMinutePresentAss_1 = cleanedItem.latesUtPerMinute;
    payrollData.absAirportAss_1 = cleanedItem.abs2;
    payrollData.lateUTperMinuteAirportAss_1 = cleanedItem.latesUtPerMinute2;
    payrollData.absPresentAss_2 = cleanedItem.absencesLeaves;
    payrollData.lateUTperMinutePresentAss_2 = cleanedItem.latesUtPerMinute3;
    payrollData.absAirportAss_2 = cleanedItem.absencesLeaves2;
    payrollData.lateUTperMinuteAirportAss_2 = cleanedItem.latesUtPerMinute4;
    payrollData.selectedDate = cleanedItem.monthNamesArr;
  } else if (caseChecker("isTirteenthCase")) {
    payrollData.netAmount = netPay;
  } else if (caseChecker("isFourteenthCase")) {
    payrollData.earnedForThePeriodFrom = cleanedItem.earnedForThePeriod;
    payrollData.earnedForThePeriodTo = cleanedItem.earnedForThePeriod2;
    payrollData.twentyPercentEarned = cleanedItem["20EarnedAmount"];
    payrollData.threePercent = cleanedItem[3];
    payrollData.netAmount = netPay;
  }
  return payrollData;
};

export const _getMatchedFields = ({
  checkCase,
  otherCalculations,
  isSeventh,
  getPositionTitle,
}) => {
  const commonProp = {
    id: "id",
    employeeNumber: "agency",
    acctNo: "accountNumber",
    ln: "surname",
    fn: "Firstname",
    mn: "Middlename",
    [isSeventh ? "gross" : "basic"]: "salaryGrade",
  };
  const cases = {
    isFirstCase: () => {
      const { firstCaseLists } = otherCalculations;
      return {
        ...commonProp,
        payrollCode: (obj) => firstCaseLists[obj.id]?.payrollCode,
        earnedBasic: (obj) => firstCaseLists[obj.id]?.earnedBasic,
        earnedPeraAda: (obj) => firstCaseLists[obj.id]?.earnedPeraAda,
        // tax: (obj) => firstCaseLists[obj.id]?.tax,
        pera: (obj) => firstCaseLists[obj.id]?.pera,
        netPay: (obj) => firstCaseLists[obj.id]?.netAmount,
        // netofMandatory: (obj) => firstCaseLists[obj.id]?.netMandatory,
        // taxDue: (obj) => firstCaseLists[obj.id]?.taxDue,
        daysInAMonth: (obj) => firstCaseLists[obj.id]?.daysInMonth,
        // gsisInsuredDays: (obj) => firstCaseLists[obj.id]?.gsisInsuredDays,
      };
    },
    isSecondCase: () => {
      const { secondCaseLists } = otherCalculations;
      return {
        ...commonProp,
        payrollCode: (obj) => secondCaseLists[obj.id]?.payrollCode,
        pera: (obj) => secondCaseLists[obj.id]?.pera,
        minutesToBeDeducted: (obj) => secondCaseLists[obj.id]?.minsToBeDeduc,
        daysToBeDeducted: (obj) => secondCaseLists[obj.id]?.daysTobeDeduc,
        halfDaysToBeDeducted: (obj) => secondCaseLists[obj.id]?.halfDaysDeduc,
        dateOfAbsences: (obj) => secondCaseLists[obj.id]?.dateOfAbsences,
        dateOfHalfDays: (obj) => secondCaseLists[obj.id]?.dateOfHalfDays,
        leaveWithoutPayDates: (obj) => secondCaseLists[obj.id]?.dateOfLeaves,
        gsisInsuredDays: (obj) => secondCaseLists[obj.id]?.gsisInsuredDays,
        deductionsDueToLeavesAbsencesAndTardinessBasic: (obj) =>
          secondCaseLists[obj.id]?.leaveAbsenceTardyDeducts,
        deductionPeraAda: (obj) => secondCaseLists[obj.id]?.peraDeducts,
        earnedBasic: (obj) => secondCaseLists[obj.id]?.earnedBasic,
        earnedPeraAda: (obj) => secondCaseLists[obj.id]?.earnedPeraAda,
        daysInAMonth: (obj) => secondCaseLists[obj.id]?.daysInMonth,
        // netofMandatory: (obj) => secondCaseLists[obj.id]?.netMandatory,
        // tax: (obj) => secondCaseLists[obj.id]?.tax,
        // taxDue: (obj) => secondCaseLists[obj.id]?.taxDue,

        netPay: (obj) => secondCaseLists[obj.id]?.netAmount,
      };
    },
    isThirdCase: () => {
      const { thirdCaseLists } = otherCalculations;

      console.log("thirdCaseLists", thirdCaseLists);
      return {
        ...commonProp,
        payrollCode: (obj) => thirdCaseLists[obj.id]?.payrollCode,
        peraAda: (obj) => thirdCaseLists[obj.id]?.pera,
        overpaymentBasic: (obj) => thirdCaseLists[obj.id]?.overpaymentBasic,
        overpaymentPeraAda: (obj) => thirdCaseLists[obj.id]?.overpaymentPeraAda,
        earnedBasic: (obj) => thirdCaseLists[obj.id]?.earnedBasic,
        earnedPeraAda: (obj) => thirdCaseLists[obj.id]?.earnedPeraAda,
        tax: (obj) => thirdCaseLists[obj.id]?.tax,
        pagibig: (obj) => thirdCaseLists[obj.id]?.pagibig,
        phic: (obj) => thirdCaseLists[obj.id]?.phicArr,
        netPay: (obj) => thirdCaseLists[obj.id]?.netAmount,
      };
    },
    isFourthCase: () => {
      const { fourthCaseLists } = otherCalculations;
      return {
        ...commonProp,
        y247N700530: "assignedArea",
        payrollCode: (obj) => fourthCaseLists[obj.id]?.payrollCode,
        noOfDuties: (obj) => fourthCaseLists[obj.id]?.daysInAirport,
        apRate: (obj) => fourthCaseLists[obj.id]?.apRate,
        // tax: (obj) => fourthCaseLists[obj.id]?.tax,
        abs: (obj) => fourthCaseLists[obj.id]?.daysTobeDeduc,
        OfDutyForCiaMciaBinocRangeTo1519: (obj) =>
          fourthCaseLists[obj.id]?.numberOfDuty,
        totalDaysDuty: (obj) => fourthCaseLists[obj.id]?.numberOfDuty,
        abs2: (obj) => fourthCaseLists[obj.id]?.daysToBeDeducAirport,
        latesUtPerMinute2: (obj) =>
          fourthCaseLists[obj.id]?.minsToBeDeducAirport,
        overpayment: (obj) => fourthCaseLists[obj.id]?.overpayment,
        flagRaising: (obj) => fourthCaseLists[obj.id]?.flagRaising,
        latesUtPerMinute: (obj) => fourthCaseLists[obj.id]?.minsToBeDeduc,
        proratedApRate: (obj) => fourthCaseLists[obj.id]?.proratedApRate,
        absencesLeaves: (obj) => fourthCaseLists[obj.id]?.absencesLeaves_1,
        earnedCurrentAssignment: (obj) =>
          fourthCaseLists[obj.id]?.earnedCurrAss,
        latesUtPerMinute3: (obj) => fourthCaseLists[obj.id]?.lateUtCurrentAss,
        airportAugmentationRate: (obj) =>
          fourthCaseLists[obj.id]?.apAugmentationRate,
        amountEarnedAirportAugmentation: (obj) =>
          fourthCaseLists[obj.id]?.airportAugAmt,
        absencesLeaves2: (obj) => fourthCaseLists[obj.id]?.absencesLeaves_2,
        latesUtPerMinute4: (obj) => fourthCaseLists[obj.id]?.lateUtAirportAss,
        earnedAirportDuties: (obj) =>
          fourthCaseLists[obj.id]?.airportDutyEarned,
        totalEarned: (obj) => fourthCaseLists[obj.id]?.totalEarned,
        netEarned: (obj) => fourthCaseLists[obj.id]?.netEarned,
        netAmount: (obj) => fourthCaseLists[obj.id]?.netAmount,
        // taxDue: (obj) => fourthCaseLists[obj.id]?.taxDue,
      };
    },
    isFifthCase: () => {
      const { fifthCaseLists } = otherCalculations;
      return {
        ...commonProp,
        daysToBeDeducted: (obj) => fifthCaseLists[obj.id]?.daysTobeDeduc,
        minsToBeDeducted: (obj) => fifthCaseLists[obj.id]?.minsToBeDeduc,
        absencesDays: (obj) => fifthCaseLists[obj.id]?.absencesDays,
        absencesMins: (obj) => fifthCaseLists[obj.id]?.absencesMins,
        overpayment: (obj) => fifthCaseLists[obj.id]?.overpayment,
        flagRaising: (obj) => fifthCaseLists[obj.id]?.flagRaising,
        3: (obj) => fifthCaseLists[obj.id]?.threePercent,
        basic: (obj) => fifthCaseLists[obj.id]?.salary,
        // 2: (obj) => fifthCaseLists[obj.id]?.twoPercent,
        // 5: (obj) => fifthCaseLists[obj.id]?.fivePercent,
        // 10: (obj) => fifthCaseLists[obj.id]?.tenPercent,
        earnedForThePeriod: (obj) => fifthCaseLists[obj.id]?.earnedFoPeriod,
        totalTax: (obj) => fifthCaseLists[obj.id]?.totalTax,
        netPay: (obj) => fifthCaseLists[obj.id]?.netPay,
      };
    },
    isSixthCase: () => {
      const { sixthCaseLists } = otherCalculations;
      return {
        ...commonProp,
        overpayment: (obj) => sixthCaseLists[obj.id]?.overpayment,
        flagRaising: (obj) => sixthCaseLists[obj.id]?.flagRaising,
        noOfDays: (obj) => sixthCaseLists[obj.id]?.noOfDays,
        3: (obj) => sixthCaseLists[obj.id]?.threePercent,
        2: (obj) => sixthCaseLists[obj.id]?.twoPercent,
        5: (obj) => sixthCaseLists[obj.id]?.fivePercent,
        10: (obj) => sixthCaseLists[obj.id]?.tenPercent,
        totalTax: (obj) => sixthCaseLists[obj.id]?.totalTax,
      };
    },
    isSeventhCase: () => {
      const { seventhCaseLists } = otherCalculations;
      return {
        ...commonProp,
        plantillaItems: getPositionTitle,
        peraAda: (obj) => seventhCaseLists[obj.id]?.pera,
        inService: (obj) => seventhCaseLists[obj.id]?.inService,
        OfDays1Month: (obj) => seventhCaseLists[obj.id]?.daysInMonth,
        holWkendsOff: (obj) => seventhCaseLists[obj.id]?.holWkendsOff,
        proratedRate: (obj) => seventhCaseLists[obj.id]?.proratedRate,
        proratedPera: (obj) => seventhCaseLists[obj.id]?.proratedPera,
        perDay: (obj) => seventhCaseLists[obj.id]?.perDay,
        perMinute: (obj) => seventhCaseLists[obj.id]?.perMinute,
        perDay2: (obj) => seventhCaseLists[obj.id]?.perDay2,
        perMinute2: (obj) => seventhCaseLists[obj.id]?.perMinute2,
        days: (obj) => seventhCaseLists[obj.id]?.daysTobeDeduc,
        halfDays: (obj) => seventhCaseLists[obj.id]?.halfdaysTobeDeduc,
        mins: (obj) => seventhCaseLists[obj.id]?.minsToBeDeduc,
        days2: (obj) => seventhCaseLists[obj.id]?.days2,
        halfDays2: (obj) => seventhCaseLists[obj.id]?.halfDays2,
        mins2: (obj) => seventhCaseLists[obj.id]?.mins2,
        basic: (obj) => seventhCaseLists[obj.id]?.basic,
        days3: (obj) => seventhCaseLists[obj.id]?.days3,
        mins3: (obj) => seventhCaseLists[obj.id]?.mins3,
        pera: (obj) => seventhCaseLists[obj.id]?.pera2,
        daysForGsis: (obj) => seventhCaseLists[obj.id]?.insuredDays,
        basicEarned: (obj) => seventhCaseLists[obj.id]?.basicEarned,
        peraAdaEarned: (obj) => seventhCaseLists[obj.id]?.peraEarned,
        total: (obj) => seventhCaseLists[obj.id]?.total,
        netPay: (obj) => seventhCaseLists[obj.id]?.netPay,
      };
    },
    isEightCase: () => {
      const { eightCaseLists } = otherCalculations;

      console.log("eightCaseLists", eightCaseLists);
      return {
        ...commonProp,
        y247N700530: "assignedArea",
        plantillaItems: getPositionTitle,
        OfDutyForCiaMciaBinocRangeTo1519: (obj) =>
          eightCaseLists[obj.id]?.numberOfDuty,
        overpayment: (obj) => eightCaseLists[obj.id]?.overpayment,
        flagRaising: (obj) => eightCaseLists[obj.id]?.flagRaising,
        tax: (obj) => eightCaseLists[obj.id]?.tax,
        apRate: (obj) => eightCaseLists[obj.id]?.apRate,
        payCode: (obj) => eightCaseLists[obj.id]?.payCode,
        daysEarned: (obj) => eightCaseLists[obj.id]?.daysEarned,
      };
    },
    isNinthCase: () => {
      const { ninthCaseLists } = otherCalculations;
      return {
        ...commonProp,
        representationAllowanceTransportationAllowanceRata: (obj) =>
          ninthCaseLists[obj.id]?.rata,
        numberOfWorkdaysOfActualWorkPerformanceInAMonth: (obj) =>
          ninthCaseLists[obj.id]?.inService,
        actualRataForAMonth: (obj) => ninthCaseLists[obj.id]?.concatPercent,
        netAmount: (obj) => ninthCaseLists[obj.id]?.netAmount,
      };
    },
    isTenthCase: () => {
      const { tenthCaseLists } = otherCalculations;
      return {
        ...commonProp,
        // oldItem: (obj) => tenthCaseLists[obj.id]?.oldPositionTitle,
        // oldRate: (obj) => tenthCaseLists[obj.id]?.oldSalaryGrade,
        // newItem: getPositionTitle,
        // newRate: (obj) => tenthCaseLists[obj.id]?.salary,
        totalAmtEarned: (obj) => tenthCaseLists[obj.id]?.salaryDifferential,
        gsis: (obj) => tenthCaseLists[obj.id]?.gsis,
        philhealth: (obj) => tenthCaseLists[obj.id]?.phic,
        tax: (obj) => tenthCaseLists[obj.id]?.tax,
        netPay: (obj) => tenthCaseLists[obj.id]?.netPay,
        oldPositionTitle: (obj) => tenthCaseLists[obj.id]?.oldPositionTitle,
        oldSalaryGrade: (obj) => tenthCaseLists[obj.id]?.oldSalaryGrade,
      };
    },
    isEleventhCase: () => {
      const { eleventhCaseLists } = otherCalculations;
      return {
        ...commonProp,
        basicSalary: (obj) => eleventhCaseLists[obj.id]?.salary,
        OfDutyForCiaMciaBinocRangeTo1519: (obj) =>
          eleventhCaseLists[obj.id]?.numberOfDuty,
        // perDay: (obj) => eleventhCaseLists[obj.id]?.perDay,
        // perMinute: (obj) => eleventhCaseLists[obj.id]?.perMinute,
        proratedRate: (obj) => eleventhCaseLists[obj.id]?.proratedRate,
        // daysDeducted: (obj) => eleventhCaseLists[obj.id]?.daysTobeDeduc,
        minsDeducted: (obj) => eleventhCaseLists[obj.id]?.minsToBeDeduc,
        // absDays: (obj) => eleventhCaseLists[obj.id]?.absDays,
        absMins: (obj) => eleventhCaseLists[obj.id]?.absMins,
        noOfDaysPresent: (obj) => eleventhCaseLists[obj.id]?.inService,
        earned: (obj) => eleventhCaseLists[obj.id]?.earned,
        20: (obj) => eleventhCaseLists[obj.id]?.twentyPercent,
        totalEarned: (obj) => eleventhCaseLists[obj.id]?.totalEarned,
        tax3: (obj) => eleventhCaseLists[obj.id]?.threePercent,
        // 2: (obj) => eleventhCaseLists[obj.id]?.twoPercent,
        netAmount: (obj) => eleventhCaseLists[obj.id]?.netAmount,
      };
    },
    isTwelvethCase: () => {
      const { twelveCaseLists } = otherCalculations;
      return {
        ...commonProp,
        y247N700530: "assignedArea",
        apRate: (obj) => twelveCaseLists[obj.id]?.apRate,
        OfDutyForCiaMciaBinocRangeTo1519: (obj) =>
          twelveCaseLists[obj.id]?.ciaMciaBinoc,
        totalDaysDuty: (obj) => twelveCaseLists[obj.id]?.ciaMciaBinoc,
        excessAirportDuties: (obj) =>
          twelveCaseLists[obj.id]?.excessAirportDuties,
        overpayment: (obj) => twelveCaseLists[obj.id]?.overpayment,
        flagRaising: (obj) => twelveCaseLists[obj.id]?.flagRaising,
        payCode: (obj) => twelveCaseLists[obj.id]?.payCode,
        tax: (obj) => twelveCaseLists[obj.id]?.tax,
        
      };
    },
    isTirteenthCase: () => {
      const { tirteenthCaseLists } = otherCalculations;
      return {
        ...commonProp,
        netPay: (obj) => tirteenthCaseLists[obj.id]?.netAmount,
      };
    },
    isFourteenthCase: () => {
      const { fourteenthCaseLists } = otherCalculations;
      return {
        ...commonProp,
        earnedForThePeriod: (obj) => fourteenthCaseLists[obj.id]?.earnedFrom,
        earnedForThePeriod2: (obj) => fourteenthCaseLists[obj.id]?.earnedTo,
        totalEarned: (obj) => fourteenthCaseLists[obj.id]?.totalEarned,
        year: (obj) => fourteenthCaseLists[obj.id]?.year,
        "20EarnedAmount": (obj) => fourteenthCaseLists[obj.id]?.twentyPercent,
        3: (obj) => fourteenthCaseLists[obj.id]?.threePercent,
        netPay: (obj) => fourteenthCaseLists[obj.id]?.netAmount,
        // netPay: (obj) => fourteenthCaseLists[obj.id]?.netAmount,
      };
    },
  };
  for (const caseKey in cases) {
    if (checkCase(caseKey)) return cases[caseKey]();
  }
  return null;
};

export const _getContributions = (item, contributions) => {
  return Object.keys(contributions).reduce((acc, key) => {
    const value = item[key] !== undefined ? item[key] : contributions[key];
    acc.push(`${key}:  ${isNaN(value) ? value : Number(value)}`);
    return acc;
  }, []);
};

export const _getCsvData = (item, csv) => {
  const found = (csv ?? []).find(
    (csvItem) =>
      Number(csvItem?.agencyEmployeeNo) === Number(item?.employeeNumber)
  );
  if (!found || typeof found !== "object") return {};
  const { agencyEmployeeNo, ...rest } = found;
  return rest;
};

export const _getCsvDataKeys = (matchedCsvData) => {
  return matchedCsvData
    ? Object.keys(matchedCsvData).filter(
        (key) => key !== "agencyEmployeeNo" && key !== "tax"
      )
    : [];
};
